export const hasValue = (value) => {
    if (value === "" || value === null || value === undefined) {
        return false;
    }
    return true;
}

// Allows: any letter (Latin, Arabic, CJK, Cyrillic, etc.), combining marks,
// digits, whitespace, and common name punctuation (. - ' ’ ,).
// Rejects: emoji, control chars, slashes, asterisks, brackets, semicolons, etc.
const SAFE_NAME_PATTERN = /^[\p{L}\p{M}\p{N}\s.\-'’,]+$/u;
const HAS_LETTER = /\p{L}/u;

export const validateName = (value, { min = 2, max = 100 } = {}) => {
    const trimmed = (value ?? "").trim();
    if (!trimmed) {
        return { valid: false, error: "Name is required" };
    }
    if (trimmed.length < min) {
        return { valid: false, error: `Name must be at least ${min} characters` };
    }
    if (trimmed.length > max) {
        return { valid: false, error: `Name must be ${max} characters or less` };
    }
    if (!SAFE_NAME_PATTERN.test(trimmed)) {
        return { valid: false, error: "Name contains invalid characters" };
    }
    if (!HAS_LETTER.test(trimmed)) {
        return { valid: false, error: "Name must contain at least one letter" };
    }
    return { valid: true, value: trimmed };
};

// Phone number validation:
// - Allowed characters: + digits whitespace - ( ) .
// - Must start with the international "+" prefix
// - Total digit count between 4 and 15 (E.164 cap)
const SAFE_PHONE_PATTERN = /^[+\d\s\-().]+$/;

export const validatePhoneNumber = (value) => {
    const trimmed = (value ?? "").trim();
    if (!trimmed) {
        return { valid: false, error: "Phone number is required" };
    }
    if (!SAFE_PHONE_PATTERN.test(trimmed)) {
        return { valid: false, error: "Phone number contains invalid characters" };
    }
    if (!trimmed.startsWith("+")) {
        return {
            valid: false,
            error: "Phone number must include the international code (e.g. +61 for Australia)",
        };
    }
    const digits = trimmed.replace(/\D/g, "");
    if (digits.length < 4 || digits.length > 15) {
        return { valid: false, error: "Phone number must have 4–15 digits" };
    }
    return { valid: true, value: trimmed };
};

export const ProcessAPIError = (error) => {
    if (hasValue(error?.response?.data?.error)) {
        return error.response.data.error;
    }
    return "There is some error processing your request. Please try after some time";
}


// UUID generator function
export const generateUUID = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      const r = Math.random() * 16 | 0;
      const v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  };
  
  // Simple string hashCode function (similar to Java's hashCode)
  export const hashCode = (str) => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      const char = str.charCodeAt(i);
      hash = ((hash << 5) - hash) + char;
      hash = hash & hash; // Convert to 32bit integer
    }
    return Math.abs(hash); // Ensure positive number
  };